import { render, staticRenderFns } from "./channelList.vue?vue&type=template&id=42313ace&scoped=true&"
import script from "./channelList.vue?vue&type=script&lang=ts&"
export * from "./channelList.vue?vue&type=script&lang=ts&"
import style0 from "./channelList.vue?vue&type=style&index=0&id=42313ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42313ace",
  null
  
)

export default component.exports